import RouteLineProvider from "./RouteLine/RouteLineProvider";

const MapViewProviders = ({ children }: { children: React.ReactNode }) => {
  return (
    <>
      <RouteLineProvider>{children}</RouteLineProvider>
    </>
  );
};

export default MapViewProviders;
